import Stack from '@mui/material/Stack';

import { RowProps, RowSpacing } from './row.types';

const spacingMapping: Record<RowSpacing, number> = {
	dense: 1,
	none: 0,
	normal: 2
};

export const VerticalRow = ({ spacing = 'normal', children }: RowProps) => {
	return (
		<Stack
			spacing={spacingMapping[spacing]}
			direction='column'
			justifyContent='center'
			alignItems='center'
			width='100%'
		>
			{children}
		</Stack>
	);
};

export const VerticalRowLeftAlign = ({ spacing = 'normal', children }: RowProps) => {
	return (
		<Stack spacing={spacingMapping[spacing]} width='100%'>
			{children}
		</Stack>
	);
};
